import * as types from '../actionsTypes/notifsActionTypes';


export const notifDismiss = (id) => {
    return {type: types.NOTIF_DISMISS, notifDismissId: id};
};

export const notifClear = () => ({
   type: types.NOTIF_CLEAR
});

export const notifReset = () => ({
    type: types.RESET_NOTIF
});

export const notifError = (message) => {
    // Calcola il tempo di visualizzazione in base al numero di righe
    const calculateDismissAfter = (msg) => {
        if (!msg) return 7000;
        
        // Converti in stringa se necessario
        const messageText = typeof msg === 'string' ? msg : 
                           Array.isArray(msg) ? msg.join('\n') : 
                           String(msg);
        
        // Conta le righe (usando \n come separatore)
        const lines = messageText.split('\n').length;
        
        // Se multiriga (più di 1 riga), usa 30 secondi
        // Altrimenti usa il tempo standard aumentato a 10 secondi
        return lines > 1 ? 30000 : 10000;
    };
    
    return {
        type: types.NOTIF_SEND,
        payload: {type: 'danger', message: message, dismissAfter: calculateDismissAfter(message)}
    };
};

export const notifSuccess = (message) =>
    ({
        type: types.NOTIF_SEND,
        payload: {type: 'success', message: message, dismissAfter: 7000}
    });

export const notifWarning = (message, dismissAfter = 7000) =>
    ({
        type: types.NOTIF_SEND,
        payload: {type: 'warning', message: message, dismissAfter: dismissAfter}
    });

